export default "__VITE_ASSET__1QlRENgc__"